import { Provider } from '@angular/core';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbTimeAdapter,
  NgbTimepickerI18n,
} from '@ng-bootstrap/ng-bootstrap';

import { CustomDatepickerI18n, I18n } from './custom-datepicker';
import { CustomNgbDateNativeAdapterToString } from './date-native-adaptor';
import { CustomNgbDateParser } from './custom-ngb-date-parser';
import { CustomNgbTimeAdapter } from './custom-time-native-adaptor';
import { CustomTimepickerI18n } from './custom-timepicker';

/**
 * Buddhist-era (พ.ศ.) date/time adapters, parsers and i18n for the
 * gt-ng-datepicker components. Register once at the application root
 * (replaces the former `GtNgDatepickerModule` providers).
 */
export function provideGtNgDatepicker(): Provider[] {
  return [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateAdapter, useClass: CustomNgbDateNativeAdapterToString },
    { provide: NgbDateParserFormatter, useClass: CustomNgbDateParser },
    { provide: NgbTimeAdapter, useClass: CustomNgbTimeAdapter },
    { provide: NgbTimepickerI18n, useClass: CustomTimepickerI18n },
  ];
}
